import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AlertProvider } from './contexts/AlertContext';
import { ApiProvider } from './contexts/ApiContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/routing/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import CompanyPage from './pages/CompanyPage';
import CompanyMenuPage from './pages/CompanyMenuPage';
import ListCompanyRequirementsPage from './pages/ListCompanyRequirementsPage';
import CustomersPage from './pages/CustomersPage';
import DashboardPage from './pages/DashboardPage';
import ListRequirementsPage from './pages/ListRequirementsPage';
import RequirementDetailPage from './pages/RequirementDetailPage';
import './App.css';

const App: React.FC = () => {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <AlertProvider>
                    <Router>
                        <ApiProvider>
                            <div className="App">
                                <Routes>
                                <Route path="/" element={<LoginPage />} />
                                <Route
                                    path="/dashboard"
                                    element={
                                        <ProtectedRoute>
                                            <DashboardPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/profile"
                                    element={
                                        <ProtectedRoute>
                                            <ProfilePage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/company-menu"
                                    element={
                                        <ProtectedRoute>
                                            <CompanyMenuPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/company"
                                    element={
                                        <ProtectedRoute>
                                            <CompanyPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/company-requirements"
                                    element={
                                        <ProtectedRoute>
                                            <ListCompanyRequirementsPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/customers"
                                    element={
                                        <ProtectedRoute>
                                            <CustomersPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/requirements"
                                    element={
                                        <ProtectedRoute>
                                            <ListRequirementsPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/requirement-detail"
                                    element={
                                        <ProtectedRoute>
                                            <RequirementDetailPage />
                                        </ProtectedRoute>
                                    }
                                />
                                </Routes>
                            </div>
                        </ApiProvider>
                    </Router>
                </AlertProvider>
            </AuthProvider>
        </ErrorBoundary>
    );
};

export default App;